import withABExperiment from "components/withABExperiment/withAbExperiment";
import GlobalSearchTypeA from "./experiment-a/globalSearch";
import GlobalSearchTypeB from "./experiment-b/globalSearch";

const experimentName = "GLOBAL_SEARCH" 

const GlobalSearch = withABExperiment({VariantComponentA: GlobalSearchTypeA, VariantComponentB: GlobalSearchTypeB, experimentName});

export default GlobalSearch

